<style lang="scss"
       module>
@import '../brand/_brandColors.scss';
@import '../brand/structure.variables';

.header {
  width: 100%;
  background-color: $blue;
  padding: 0.5rem $mobile-spacing;
  font-family: 'Open Sans Condensed', sans-serif;
  font-size: 1rem;
  line-height: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  color: $white;
  text-align: center;
}

.wrapper {
  composes: wrapper from 'sass-loader!../brand/structure.module.scss';
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.noMargin {
  margin-top: 0;
  margin-bottom: 0;
  color: $white;
  background: none;
  border: 0;
  text-decoration: underline;
  cursor: pointer;
}

.emphasis {
  color: $orange;
}

.privacy {
  color: $gray;
  text-transform: none;
  p {
    text-align: left;
  }
  h3 {
    text-align: left;
  }
}

@media screen and (min-width: $mobile) {
  .header {
    padding: 1rem;
  }
}
</style>
<template>
  <div :class="$style.header">
    <div :class="$style.wrapper">
      <button
        :class="$style.noMargin"
        @click="openPrivacy">Terms & Conditions
      </button>
      <SweetModal
        ref="privacy"
        :class="$style.privacy">
        <h3>Acceptance of Contract Terms</h3>
        <p>The following are the terms of a legal agreement between you and GO2 Partners, Inc. By accessing, browsing and/or using this website, you acknowledge that you have read, understand, and agree to be bound by these terms and to comply with all applicable laws and regulations, including export and re-export control laws and regulations. If you do not agree to these terms, do not use this website. The material provided on this website is protected by law, including, but not limited to, United States Copyright Law and international treaties. Any claim relating to, and the use of, this website and the materials contained herein is governed by the laws of the state of Illinois.</p>
        <p>The copyright in all material provided on this website is held by GO2 Partners, Inc. or by the original creator of the material. Except as stated herein, none of the material may be copied, reproduced, distributed, republished, downloaded, displayed, posted or transmitted in any form or by any means, including, but not limited to, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of GO2 Partners, Inc. or the copyright owner. Permission is granted to display, copy, distribute and download the materials on this website for the purpose of designing materials to be printed by GO2 Partners, Inc., provided you do not modify the templates or materials and that you retain all copyright and other proprietary notices contained in the materials. This permission terminates automatically if you breach any of these terms or conditions. Upon termination, you must immediately destroy any downloaded and printed materials. You also may not, without GO2 Partners, Inc. permission, "mirror" any material contained on this website onto any other server. Any unauthorized use of any material contained on this website may violate copyright laws, trademark laws, the laws of privacy and publicity, and communications regulations and statutes. This website may contain other proprietary notices and copyright information, the terms of which must be observed and followed. Information on this website may contain technical inaccuracies or typographical errors.</p>
        <p> GO2 Partners, Inc. assumes no responsibility regarding the accuracy of the information that is provided by GO2 Partners, Inc. and the use of such information is at the recipient's own risk. GO2 Partners, Inc. provides no assurances that any reported problems may be resolved with the use of any information that GO2 Partners, Inc. provides. By furnishing information, GO2 Partners, Inc. does not grant any licenses to any copyrights, patents, trademarks, or any other intellectual property rights.</p>
        <h3> Limitation of Liability</h3>
        <p> UNDER NO CIRCUMSTANCES, INCLUDING, BUT NOT LIMITED TO, NEGLIGENCE, SHALL GO2 PARTNERS, INC. BE LIABLE FOR ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES, INCLUDING, BUT NOT LIMITED TO, LOSS OF DATA OR PROFIT, ARISING OUT OF THE USE, OR THE INABILITY TO USE THE MATERIALS ON THIS WEBSITE, EVEN IF GO2 PARTNERS, INC. OR A GO2 PARTNERS, INC. AUTHORIZED REPRESENTATIVE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IF YOUR USE OF MATERIALS FROM THIS WEBSITE RESULTS IN THE NEED FOR SERVICING, REPAIR OR CORRECTION OF EQUIPMENT OR DATA, YOU ASSUME ANY COSTS THEREOF. SOME STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU.</p>
        <h3> Our Transmissions</h3>
        <p> GO2 Partners, Inc. does not want to receive confidential or proprietary information from you through our website. Please note that any information or material sent to GO2 Partners, Inc. will be deemed NOT to be confidential. Any material, information or idea you transmit to or post on this Site by any means will be treated as non-confidential and non-proprietary, and may be disseminated or used by GO2 Partners, Inc. or its affiliates for any purpose whatsoever, including, but not limited to, developing, manufacturing and marketing products. However, we will not release your name nor otherwise publicize the fact that you submitted materials or other information to us unless: (a) we obtain your permission to use your name; or (b) we first notify you that the materials or other information you submit to a particular part of this site will be published or otherwise used with your name on it; (c) we are requested to supply the information by your employer or the organization sponsoring your access to this website, or (d) we are required to do so by law.</p>
        <p> Notwithstanding the foregoing, all personal data provided to GO2 Partners, Inc. will be handled in accordance with GO2 Partners, Inc. Online Privacy Practices. You are prohibited from posting or transmitting to or from this Site any unlawful, threatening, libelous, defamatory, obscene, scandalous, inflammatory, pornographic, or profane material, or any other material that could give rise to any civil or criminal liability under the law.</p>
        <h3> Term of Use Revisions</h3>
        <p> GO2 Partners, Inc. may at any time revise these Terms of Use by updating this posting. By using this Site, you agree to be bound by any such revisions and should therefore periodically visit this page to determine the then current Terms of Use to which you are bound.</p>
        <h3> Privacy Policy</h3>
        <p> We respect your privacy. When you browse the GO2 Partners, Inc. website, you are able to do so anonymously. We do not collect personal information when you browse. Your browser, however, does automatically tell us the type of computer and operating system you are using. We only use this information to improve the design and ease of use of our web site. This information is in no way linked back to you personally.</p>
        <p> We only collect personal information about you when you sign up for our newsletter. This information is not sold to anyone. If you have any questions concerning our collection and/or use of your personal information, please feel free to contact us.

        Last updated April 17, 2014.
        </p>
      </SweetModal>
    </div>
  </div>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';

/* Methods */
/* Everything else */

export default {
  name: 'AppFooter',
  components: {
    SweetModal,
    SweetModalTab,
  },
  methods: {
    openPrivacy() {
      this.$refs.privacy.open();
    },
  },
};
</script>
